module.exports = __webpack_public_path__ + "img/ic_launcher.2fb3c638.png";